import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// Import SVG assets
// Asset Monitoring SVG
import Host from "../../assets/images/HOSTSDISC_Dashboard.svg"; // Hosts Discovered
import HostLocation from "../../assets/images/HOSTLOC_Dashboard.svg"; // Hosts Locations
import CloudProviderSvg from "../../assets/images/CLOUDPROV_Dashboard.svg"; // Cloud Provider
import OpenPorts from "../../assets/images/OPENPORTS_Dashboard.svg"; // Open Ports
import OpertingSystem from "../../assets/images/OS_Dashboard.svg"; // Operating Systems
import networkService from "../../assets/images/NETWSERV_Dashboard.svg"; // Network Services
// Security Healthcheck SVG
import DNS from "../../assets/images/DNS_Dashboard.svg"; // DNS Health
import SUBDOM from "../../assets/images/SUBDOM_Dashboard.svg"; // Subdomain Health
import Known from "../../assets/images/VULNERAB_Dashboard.svg"; // Known Vulnerabilities
import SSL from "../../assets/images/SSLCERT_Dashboard.svg"; // SSL Certificates
/*import WEBTECH from "../../assets/images/image-gallery/web_technologies.svg";*/ // Web Technologies
import WEBTECH from "../../assets/images/menu_icons/WebTechnologies_Dashboard.svg"; // Web Technologies
// Brand Security SVG
import BrandMention from "../../assets/images/menu_icons/BrandMentions_Dashboard.svg"; // Brand Mentions
import FakeApp from "../../assets/images/FAKEAPP_Dashboard.svg"; // Fake Mobile Applications
import LookAlike from "../../assets/images/image-gallery/Icon_1.svg"; // Look - Alike
import FakeSM from "../../assets/images/FAKESME_Dashboard.svg"; // Fake Social Media Profiles
// Breach Detection SVG
import StolenCred from "../../assets/images/STOLENCRED_Dashboard.svg"; // Stolen Credentials
import MalwareCred from "../../assets/images/image-gallery/malware_infected_computers.svg"; // Malware Infected Computers
import SourceCode from "../../assets/images/LEAKAGE_Dashboard.svg"; // Source Code Leakage
import LeakedSession from "../../assets/images/menu_icons/LeakedSession_Dashboard.svg"; // Leaked Sessions
import CloudBucket from "../..//assets/images/menu_icons/OpenCloudBuckets_Dashboard.svg"; // Open Cloud Buckets
import Blacklist from "../../assets/images/BLACKIP_Dashboard.svg"; // IP Blacklists
import PII from "../../assets/images/menu_icons/PIL_Dashboard.svg"; // Personal Information
/*import Pastebin from "../../assets/images/PII-Leakage_icon.svg"; // PasteBin Search*/
// Valkyrie Services SVG
import ValIdentity from "../../assets/images/Identify_Valkyrie.svg"; // Identify
import ValProtect from "../../assets/images/Protect_Valkyrie.svg"; // Protect
import ValDetect from "../../assets/images/Detect_Valkyrie.svg"; // Detect
import ValRespond from "../../assets/images/Respond_Valkyrie.svg"; // Respond
import ValRecover from "../../assets/images/Recover_Valkyrie.svg"; // Recover
import ValCustom from "../../assets/images/Custom_Valkyrie.svg"; // Custom Services
// Remediation Mode SVG
/*
import UserSvg from "../../assets/images/Users_icon.svg"; // Overview
import ProfileSvg from "../../assets/images/Profile_Icon.svg"; // Tasks
import NotificationSvg from "../../assets/images/Notifications_icon.svg"; // Tickets
import AuditLogSvg from "../../assets/images/AuditLog_icon.svg"; // Trusted Users + Activity Log
*/
// Settings Mode SVG
import UserSvg from "../../assets/images/Users_icon.svg"; // Users
import ProfileSvg from "../../assets/images/Profile_Icon.svg"; // Profile
import NotificationSvg from "../../assets/images/Notifications_icon.svg"; // Notification
import AuditLogSvg from "../../assets/images/AuditLog_icon.svg"; // Audit Log
// Quantum Readiness SVG
import QuantumSvg from "../../assets/images/menu_icons/Quantum_Dashboard.svg";
import QuantumSideMenu from "../../assets/images/menu_icons/Quantum_IconMain.svg";

const MENU_CONFIGS = {
  'settings-mode': {
    title: "Users",
    items: [
      { path: "/user/{id}", icon: UserSvg, label: "Users" },
      { path: "/profile", icon: ProfileSvg, label: "Profile" },
      { path: "/app-inbox", icon: NotificationSvg, label: "Notification" },
      { path: "/audit-log", icon: AuditLogSvg, label: "Audit Log" }
    ],
    menuIcon: "/assets/images/Assets_IconMain_.svg"
  },
  'remediationOverview': {
    title: "Remediation Mode",
    items: [
      { path: "/remediation-mode/overview", icon: UserSvg, label: "Overview", isDefault: true },
      { path: "/remediation-mode/task", icon: ProfileSvg, label: "Tasks" },
      { path: "/remediation-mode/tickets", icon: NotificationSvg, label: "Tickets" },
      { path: "/remediation-mode/trusted-user", icon: AuditLogSvg, label: "Trusted Users" },
      { path: "/remediation-mode/activity-log", icon: AuditLogSvg, label: "Activity Log" },
    ],
    menuIcon: "/assets/images/report_mode.svg"
  },
  'security': {
    title: "Security Healthcheck",
    items: [
      { path: "/security/dns-health", icon: DNS, label: "DNS Health", isDefault: true },
      { path: "/security/sub-domain", icon: SUBDOM, label: "Subdomain Health" },
      { path: "/security/known-vulnerabilities", icon: Known, label: "Known Vulnerabilities" },
      { path: "/security/ssl-certificates", icon: SSL, label: "SSL Certificates" },
      { path: "/security/web-technology", icon: WEBTECH, label: "Web Technologies" }
    ],
    menuIcon: "/assets/images/Health_IconMain_.svg"
  },
  'brand': {
    title: "Brand Security",
    items: [
      { path: "/brand/brand-mention", icon: BrandMention, label: "Brand Mentions", isDefault: true},
      { path: "/brand/mobile-apps", icon: FakeApp, label: "Mobile Applications" },
      { path: "/brand/look-alike", icon: LookAlike, label: "Look - Alike" },
      { path: "/brand/social-media", icon: FakeSM, label: "Social Media Profiles" }
    ],
    menuIcon: "/assets/images/Brand_IconMain_.svg"
  },
  'services': {
    title: "Valkyrie Services",
    items: [
      { path: "/services#identify", icon: ValIdentity, label: "Identify" },
      { path: "/services#protect", icon: ValProtect, label: "Protect" },
      { path: "/services#detect", icon: ValDetect, label: "Detect" },
      { path: "/services#respond", icon: ValRespond, label: "Respond" },
      { path: "/services#recover", icon: ValRecover, label: "Recover" },
      { path: "/services#custom", icon: ValCustom, label: "Custom Services" }
    ],
    menuIcon: "/assets/images/valkyrie_service.svg"
  },
  'knowledge': {
    title: "Knowledge Base",
    items: [
      { path: "/kb#scans", icon: ValIdentity, label: "Scans Explained" , isDefault: true },
      { path: "/kb#remediation", icon: ValIdentity, label: "Remediation Guides" },
      { path: "/kb#platform", icon: ValIdentity, label: "Platform & Tools" },
      { path: "/kb#faq", icon: ValIdentity, label: "FAQ" },
      //{ path: "/kb#troubleshoot", icon: ValIdentity, label: "Troubleshoot" },
      { path: "/kb#release-notes", icon: ValIdentity, label: "Release Notes" },
      { path: "/kb#glossary", icon: ValIdentity, label: "Glossary" }
    ],
    menuIcon: "/assets/images/valkyrie_service.svg"
  },
  'assets': {
    title: "Asset Monitoring",
    items: [
      { path: "/assets/#hostsDiscovered", icon: Host, label: "Hosts Discovered", isDefault: true },
      { path: "/assets/#hostsLocation", icon: HostLocation, label: "Hosts Locations" },
      { path: "/assets/#cloudProvider", icon: CloudProviderSvg, label: "Cloud Provider" },
      { path: "/assets/#openPort", icon: OpenPorts, label: "Open Ports" },
      { path: "/assets/#operatingSystem", icon: OpertingSystem, label: "Operating Systems" },
      { path: "/assets/#networkService", icon: networkService, label: "Network Services" }
    ],
    menuIcon: "/assets/images/Assets_IconMain_.svg"
  },
  'breach': {
    title: "Breach Detection",
    items: [
      { path: "/breach/stolen-credentials", icon: StolenCred, label: "Stolen Credentials", isDefault: true },
      { path: "/breach/malware-credentials", icon: MalwareCred, label: "Malware Infected Computers" },
      { path: "/breach/source-code", icon: SourceCode, label: "Source Code Leakage" },
      { path: "/breach/leaked-sessions", icon: LeakedSession, label: "Leaked Sessions" },
      { path: "/breach/cloud-bucket", icon: CloudBucket, label: "Open Cloud Buckets" },
      { path: "/breach/ip-blacklist", icon: Blacklist, label: "IP Blacklists" },
      { path: "/breach/pil", icon: PII, label: "Personal Information" },
      { path: "/breach/pastebin", icon: SourceCode, label: "Pastebin Search" }
    ],
    menuIcon: "/assets/images/Breach_IconMain_.svg"
  },
  'quantum': {
    title: "Quantum Readiness",
    items: [
      { path: "/quantum/overview", icon: QuantumSvg, label: "Overview", isDefault: true },
      { path: "/quantum/domain", icon: QuantumSvg, label: "Domains" },
      { path: "/quantum/system", icon: QuantumSvg, label: "Systems" },
      { path: "/quantum/application", icon: QuantumSvg, label: "Applications" },
      { path: "/quantum/file", icon: QuantumSvg, label: "Files" },
      { path: "/quantum/traffic", icon: QuantumSvg, label: "Traffic Analysis" },
      { path: "/quantum/code", icon: QuantumSvg, label: "Code Analysis" }
    ],
    menuIcon: QuantumSideMenu
  }
};

const MenuItem = ({ path, icon, label, isActive, id }) => {
  const finalPath = path.includes("{id}") ? path.replace("{id}", id) : path;
  return (
    <li>
      <Link to={finalPath} className={`text_img_sidebar ${isActive ? 'active_sidebar_check' : ''}`}>
        <div className="circle_button">
          <div className="inner_box">
            <img src={icon} className="img-fluid" alt={label} />
          </div>
        </div>
        <span>{label}</span>
      </Link>
    </li>
  );
};

const Sidenav = ({ type }) => {

  const location = useLocation();
  const { pathname, hash } = location;
  const mode = useSelector(state => state?.summary?.modes?.data || "assessment-mode");
  const id = useSelector(state => state?.summary?.localClient?._id || state?.summary?.clients?.data?.[0]?._id);

  const getMenuConfig = () => {
    if (mode === 'settings-mode') {
      return MENU_CONFIGS['settings-mode'];
    }

    if (type?.includes('security') /*|| ['/dns-health', '/sub-domain', '/known-vulnerabilities', '/ssl-certificates', '/web-technology'].includes(type)*/) {
      return MENU_CONFIGS.security;
    }
    if (type?.includes('remediation-mode')) {
      return MENU_CONFIGS.remediationOverview;
    }
    if (type?.includes('brand') /*|| ['/brand-mention', '/mobile-apps', '/look-alike', '/social-media'].includes(type)*/) {
      return MENU_CONFIGS.brand;
    }
    if (type?.includes('services')) {
      return MENU_CONFIGS.services;
    }
    if (type?.includes('kb')) {
      return MENU_CONFIGS.knowledge;
    }
    if (type?.includes('assets')) {
      return MENU_CONFIGS.assets;
    }
    if (type?.includes('quantum')) {
      return MENU_CONFIGS.quantum;
    }
    return MENU_CONFIGS.breach;
  };

  const menuConfig = getMenuConfig();


  const isItemActive = (itemPath) => {
    const [itemBasePath, itemHash] = itemPath.split('#');
    const [currentBasePath, currentHash] = pathname.split('#');
    if (itemHash) {
      return currentBasePath === itemBasePath && hash === `#${itemHash}`;
    }

    if (itemPath.includes('/user/')) {
      return pathname.startsWith('/user/');
    }

    return pathname === itemPath ||
      (itemPath.includes(pathname) && pathname !== '/') ||
      (pathname === `/${type}` && itemPath.includes(type) && menuConfig.items.find(i => i.path === itemPath)?.isDefault);
  };

  return (
    <div className="side_bar">
      <ul>
        <li>
          <a href="javascript:void(0)" className="menu_btnside">
            <img
              src={menuConfig.menuIcon || "/assets/images/image-gallery/MenuIcon.png"}
              className="img-fluid"
              alt="menu"
            />
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" className="security_check_1">
            <span>{menuConfig.title}</span>
          </a>
        </li>
        {menuConfig.items.map(item => (
          <MenuItem
            key={item.path}
            {...item}
            id={id}
            isActive={isItemActive(item.path)}
          />
        ))}
        <li>
          <a href="javascript:void(0)" className="security_check_2">
            <span>{menuConfig.title}</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Sidenav;